<template>
    <div class="script-menu">
		<Loading v-if="!loadingDone"/>
        <div class="script-set-num">
            <div class="title">剧本集数</div>    
        </div>
        <ul class="script-menu-list">
            <li v-for="(item,index) in menuList" :key="index" @click="toContentPage(item.lock,item.article_id,item.set_no)">
                <span :style="item&&item.lock!==0?'color:#999':'color:#222'">第{{item&&item.char_no}}集</span><span class="lock-icon" v-if="item&&item.lock!==0"></span>
            </li>
        </ul>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
    name:'ScriptMenu',
    data(){
        return{
            menuList:[],                  //储存剧本目录数据
            scriptType:'',                //储存剧本类型 1是电影  2是电视剧
			loadingDone:false             //控制加载画面显示隐藏
        }
    },
    created(){
        Axios.get('/article/preview/'+this.$route.params.id).then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
					this.menuList=response.data.data
					this.scriptType=this.$route.params.type
					this.loadingDone=true         
                }
            }
        )
    },
    methods:{
        //去电视剧内容页面
        toContentPage(lock,id,set){
            if(lock!==0){
                this.$swal({
					text:'填写申请指定章节表单可查看更多剧集',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1200,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				});
            }else if(lock==0){
               this.$router.push({name:'contentpage',query:{id:id,set:set,type:this.scriptType}})
            }
        }
	},
	components:{
		Loading
	}
}
</script>

<style scoped lang="scss">
    .script-menu{
       padding:0 40px;
       padding-top:88px;
       width:670px;
    }
    .script-menu-list{
        li{
            padding:40px 0;
            border-bottom:1px solid #E6E6E6;
            font-size:24px;
            color:#222;
            overflow:hidden;
            .lock-icon{
                display:inline-block;
                width:24px;
                height:24px;
                background:url('../assets/img/menulock.png') no-repeat;
                background-size:cover;
                float:right;
                transform:translateY(2px);
            }
        }
    }
</style>